export default "__VITE_ASSET__B14IdgRA__"